<template>
  <div class="bigBox">
    <!-- 表格 用户信息 -->
    <!--  :addBtnList="golist"
                   :hideAddBtn="
        !hasBtn('add-client') && !hasBtn('copy-from-exissting-client')
      " -->
    <mrc_ess_table
      v-if="$route.name == 'clientmanage'"
      :hideAddBtn="!hasBtn('add-client')"
      pageName="addnewuser"
      :headers="headers"
      :paginationOptions="options"
      @turnPage="getlist"
      :slotKey="['name']"
      :isLoading="loading"
      :items="desserts"
    >
      <template v-slot:search>
        <v-row
          class="d-flex justify-end"
          style="background: white;
          margin: 0;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;padding: 0 16px"
        >
          <mrc_ess_advanceFilterAndSearchInput
            class="mt-4"
            v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1 })"
            :systemFieldMeta="systemFieldMeta"
          ></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <template v-slot:item.name="{ item }">
        <div>
          <span>{{ INT(item.client_name) }}</span>
          <span class="n1">{{
            item.client_short_code ? "(" + item.client_short_code + ")" : ""
          }}</span>
        </div>
      </template>

      <template v-slot:item.actions="{ item }">
        <menu-list :list="menulist" @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon>mdi-dots-vertical</v-icon>
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view></router-view>
  </div>
</template>

<script>
import {
  getclientlist,
  edmitclientdetail,
} from "@/service/api/clientmanage_api.js"
export default {
  data() {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      loading: false,
      options: {
        pagesize: this.$store.state.pageSize, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      dialog: false,
      desserts: [],
    }
  },

  computed: {
    golist() {
      return [
        {
          name: this.$t("label_A_new_user"),
          page_name: "addnewuser",
          show: this.hasBtn("add-client"),
        },
        // {
        //   name: this.$t('label_Add_from_existing_users'),
        //   page_name: 'addcopyuser',
        //   show: this.hasBtn('copy-from-existing-client'),
        // },
      ]
    },
    menulist() {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-client"),
          type: "view",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-client"),
          type: "edit",
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-client"),
          type: "del",
        },
      ]
    },
    headers() {
      return [
        {
          text: this.$t("label_The_customer_name"),
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "end",
          width: "60",
        },
      ]
    },
  },
  watch: {
    $route(val) {
      //监听路由变化
      if (this.$route.name == "clientmanage") {
        // console.log('更新list');
        this.getlist()
      }
    },
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1)
  },
  async created() {
    await this.getBtnPermissionList()
  },
  beforeDestroy() {},
  async mounted() {
    await this.getlist()
  },
  methods: {
    godetail(item) {
      //详情页
      this.$store.commit("set_uuid", item.role_uuid)
      this.$store.commit("set_detailuuid", item.uuid)
      this.$store.commit("set_subPage_name", item.client_name)
      this.$store.commit("set_iconstatus", true) //图标默认显示
      this.$router.push({
        name: "clientdetail",
        params: {
          name: item.client_name,
          uuid: item.uuid,
        },
      })
    },
    // 编辑
    editPrompt(item) {
      //三点进入
      this.$store.commit("set_uuid", item.role_uuid)
      this.$store.commit("set_detailuuid", item.uuid)
      // this.$store.commit('set_detailclientname', item.client_name) subPage_name
      this.$store.commit("set_subPage_name", item.client_name)
      this.$store.commit("set_iconstatus", false) // 图标状态
      this.$router.push({
        name: "clientdetail",
        params: {
          name: item.client_name,
          uuid: item.uuid,
        },
      })
    },
    handleClick({ index, item }, obj) {
      switch (item.type) {
        case "view":
          this.godetail(obj)
          break
        case "edit":
          this.editPrompt(obj)
          break
        case "del":
          this.handleDel(obj)
          break
      }
    },
    // 删除
    handleDel(item) {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_deletion"),
      })
        .then(() => {
          edmitclientdetail({ uuid: item.uuid }).then((res) => {
            if (res.code == 200) {
              if (this.desserts.length == 1 && this.options.cpage != 1)
                this.options.cpage--
              this.$Message({
                text: this.$t("message_The_deletion_was_successful"),
              })
              this.getlist()
            }
          })
        })
        .catch(() => {})
    },
    // 获取客户列表
    async getlist(obj) {
      this.loading = true
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--
      if (obj) {
        const { cpage, pagesize } = obj
        this.options = { ...this.options, ...obj }
      }
      const res = await getclientlist({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })
      // console.log(res);
      if (res.code == 200) {
        this.desserts = res.data
        this.options.totalcount = res.totalcount
        this.options.totalpage = res.totalpage
        this.systemFieldMeta = res.systemFieldMeta
        this.field_alias_name = res.field_alias_name
        this.table_alias_name = res.table_alias_name
      }
      this.loading = false
    },
  },
}
</script>

<style scoped>
.n1 {
  font-size: 14px;
  margin-left: 15px;
  color: #ccc;
}
/* // .addbtn {
//   position: relative;
//   height: 50px;
// }
// .addbtn button {
//   font-size: 30px;
//   width: 40px;
//   height: 40px;
//   border-radius: 50%;
//   position: absolute;
//   right: 75px;
//   bottom: 30px;
//   background-color: orange;
// }
// .addBtn {
//   color: white;
//   transform: rotateZ(45deg);
// } */
</style>
